import React, { useState, useRef, useEffect } from "react";
import '../../css/components/controls/HrnbSelect.css'

export default function HrnbSelect({
                                       label,
                                       options = [],
                                       value,
                                       onChange,
                                       placeholder = "Выберите...",
                                       error = "",
                                       hint = "",
                                       disabled = false,
                                       className = "",
                                       ...props
                                   }) {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    // Закрытие по клику вне компонента
    useEffect(() => {
        if (!open) return;
        const handleClick = (e) => {
            if (ref.current && !ref.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener("mousedown", handleClick);
        return () => document.removeEventListener("mousedown", handleClick);
    }, [open]);

    const selected = options.find(opt => opt.value === value);

    return (
        <div
            className={`hrnb-select-wrap ${className} ${error ? "hrnb-select--error" : ""} ${disabled ? "hrnb-select--disabled" : ""}`}
            ref={ref}
        >
            {label && <label className="hrnb-select__label">{label}</label>}
            <div
                className="hrnb-select__control"
                tabIndex={disabled ? -1 : 0}
                onClick={() => !disabled && setOpen(v => !v)}
                {...props}
            >
                <span className={`hrnb-select__value ${!selected ? "hrnb-select__placeholder" : ""}`}>
                    {selected ? selected.label : placeholder}
                </span>
                <span className="hrnb-select__arrow" />
            </div>
            {open && !disabled && (
                <div className="hrnb-select__dropdown">
                    {options.map(opt => (
                        <div
                            key={opt.value}
                            className={`hrnb-select__option${opt.value === value ? " hrnb-select__option--selected" : ""}`}
                            onClick={() => {
                                setOpen(false);
                                onChange?.(opt.value);
                            }}
                        >
                            {opt.label}
                        </div>
                    ))}
                </div>
            )}
            {error
                ? <div className="hrnb-select__error">{error}</div>
                : hint && <div className="hrnb-select__hint">{hint}</div>
            }
        </div>
    );
}
